/* ==========================================================================
   Canticos — Store Locator
   Filtro en cascada Estado > Ciudad > ZIP, 100% client-side.

   Los datos llegan en un <script type="application/json"> que Liquid genera
   desde los metaobjects: sin llamadas de red y filtrado instantaneo.

   Los tres controles son comboboxes con busqueda escrita y tolerancia a
   errores de tipeo ("fontanaa" encuentra Fontana). No se usa <datalist>
   porque su soporte en Safari iOS es pobre, y este proyecto es mobile-first.
   ========================================================================== */
(function () {
  'use strict';

  /* Un color de acento por cadena, de la paleta real del tema.
     Es color decorativo de Canticos, NO el logo del supermercado.
     Una cadena nueva sin entrada aqui cae al azul de marca. */
  var CHAIN_ACCENT = {
    'Cardenas Markets':          '#334FB4',
    'El Super':                  '#ED7EAF',
    'Northgate González Market': '#45C1CD',
    'Food 4 Less':               '#FED130',
    "Tony's Fresh Market":       '#759DD0',
    'El Rancho Supermercado':    '#E0662F',
    "Sedano's Supermarkets":     '#3FA97A',
    'Smart & Final':             '#002198',
    'LA librería':               '#ED7EAF'
  };
  var DEFAULT_ACCENT = '#002198';

  /* Logo real de cada cadena, servido como asset de Shopify (asset_url en
     el .liquid la resuelve a CDN). Una cadena nueva sin entrada aqui no
     muestra logo de super — la card sigue mostrando el logo Canticos.

     El mapa completo vive SOLO en store-locator.liquid: antes estaba
     duplicado aqui, y agregar una cadena obligaba a editar los dos
     archivos — si se olvidaba uno, el logo no salia y nada avisaba. */
  var CHAIN_LOGO = window.CST_CHAIN_LOGOS || {};

  /* Logo de cadena: prioridad al metaobject store_chain (2026-09-03),
     con fallback al diccionario fijo CST_CHAIN_LOGOS de siempre.

     store.chainLogo viene del campo chain_ref de CADA tienda — el
     cliente lo sube una vez por cadena, no por tienda, en Contenido >
     Metaobjetos > Store Chain. Mientras una cadena no tenga esa entrada
     vinculada (migracion en curso, o cadena nueva sin configurar), esta
     funcion cae sola al diccionario de codigo: ninguna tienda se queda
     sin logo por un chain_ref vacio. */
  function chainLogoFor(store) {
    return store.chainLogo || CHAIN_LOGO[store.chain] || '';
  }

  var ICON = {
    pin: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a7 7 0 0 0-7 7c0 5.3 7 13 7 13s7-7.7 7-13a7 7 0 0 0-7-7Zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5Z"/></svg>',
    tel: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6.6 10.8c1.2 2.3 3.1 4.2 5.4 5.4l1.8-1.8c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.5.6.6 0 1 .4 1 1V19c0 .6-.4 1-1 1-9.4 0-17-7.6-17-17 0-.6.4-1 1-1h3.2c.6 0 1 .4 1 1 0 1.2.2 2.4.6 3.5.1.4 0 .8-.2 1l-1.8 1.8z"/></svg>',
    /* Logo real de Waze (icono oficial del cliente): ya trae relleno
       blanco propio con contorno negro, sin disco de fondo — funciona
       bien sobre el boton azul tal cual, sin necesitar recolorear. */
    waze: window.CST_WAZE_ICON
      ? '<img src="' + window.CST_WAZE_ICON + '" alt="" width="27" height="24" style="object-fit:contain">'
      : '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="#fff" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M4.3 10.6C4.3 6 8 2.4 12 2.4s7.7 3.6 7.7 8.2c0 3-1.8 5.3-3.7 5.3H8c-1.9 0-3.7-2.3-3.7-5.3Z"/><circle cx="9.3" cy="9.3" r="1" fill="#fff" stroke="none"/><circle cx="14.7" cy="9.3" r="1" fill="#fff" stroke="none"/><path d="M8.7 12.9c.9 1.4 2 2.1 3.3 2.1s2.4-.7 3.3-2.1"/><path d="M7.4 17.8c0 1 .8 1.8 1.8 1.8s1.8-.8 1.8-1.8"/><path d="M13.2 17.8c0 1 .8 1.8 1.8 1.8s1.8-.8 1.8-1.8"/></svg>',
    /* Logo real de Google Maps (el pin oficial en forma de gota), no la
       aproximacion redibujada a mano que habia antes (una especie de
       estrella de 4 puntas que no se parecia al oficial). */
    maps: window.CST_MAPS_ICON
      ? '<img src="' + window.CST_MAPS_ICON + '" alt="" width="24" height="24" style="object-fit:contain">'
      : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.3c2 0 3.9 1 5.1 2.5l-4 3.3-4.5-2.3A6.4 6.4 0 0 1 12 2.3Z" fill="#4285F4"/><path d="M6.9 5.8A6.3 6.3 0 0 0 5.6 9.6c0 1.2.4 2.3.9 3.2l4.7-5.5-4.3-1.5Z" fill="#FBBC04"/><path d="M17.1 4.8A6.3 6.3 0 0 1 18.4 9c0 1.6-.7 2.9-1.4 4.1l-3.8-4.8 3.9-3.5Z" fill="#34A853"/><path d="M12 21.7s-4.2-5.3-5.5-8.9L12 8.3l5.5 4.5c-1.3 3.6-5.5 8.9-5.5 8.9Z" fill="#EA4335"/><circle cx="12" cy="9.5" r="2.3" fill="#fff"/></svg>'
  };

  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ------------------------------------------------------------------
     Busqueda tolerante a errores de tipeo
     ------------------------------------------------------------------ */

  /* Distancia de Levenshtein con dos filas: suficiente para listas de
     cientos de opciones y sin coste de memoria apreciable. */
  function levenshtein(a, b) {
    if (a === b) return 0;
    if (!a.length) return b.length;
    if (!b.length) return a.length;
    var prev = new Array(b.length + 1), cur = new Array(b.length + 1), i, j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) {
      cur[0] = i;
      for (j = 1; j <= b.length; j++) {
        cur[j] = Math.min(
          prev[j] + 1,
          cur[j - 1] + 1,
          prev[j - 1] + (a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1)
        );
      }
      for (j = 0; j <= b.length; j++) prev[j] = cur[j];
    }
    return prev[b.length];
  }

  /* Devuelve { list, fuzzy }.
     Prioridad: empieza-por > contiene > parecido.
     El modo "parecido" solo entra si los dos primeros no dieron nada. */
  function searchOptions(query, options) {
    var q = String(query || '').trim().toLowerCase();
    if (!q) return { list: options.slice(), fuzzy: false };

    var starts = [], contains = [], i, label;
    for (i = 0; i < options.length; i++) {
      label = String(options[i].value).toLowerCase();
      if (label.indexOf(q) === 0) starts.push(options[i]);
      else if (label.indexOf(q) > -1) contains.push(options[i]);
    }
    if (starts.length || contains.length) {
      return { list: starts.concat(contains), fuzzy: false };
    }

    // Tolerancia proporcional al largo de lo escrito
    var tol = q.length <= 4 ? 1 : (q.length <= 7 ? 2 : 3);
    var scored = [];
    for (i = 0; i < options.length; i++) {
      label = String(options[i].value).toLowerCase();
      var d1 = levenshtein(q, label);
      // Comparo tambien contra el prefijo del mismo largo, para que
      // "hoston" case con "houston" sin castigar nombres largos.
      var d2 = label.length > q.length ? levenshtein(q, label.slice(0, q.length)) : 99;
      var dist = Math.min(d1, d2);
      if (dist <= tol) {
        // Compartir la primera letra desempata a favor de lo esperado
        var penalty = label.charAt(0) === q.charAt(0) ? 0 : 0.5;
        scored.push({ score: dist + penalty, len: label.length, opt: options[i] });
      }
    }
    scored.sort(function (a, b) { return a.score - b.score || a.len - b.len; });
    return { list: scored.map(function (s) { return s.opt; }), fuzzy: true };
  }

  /* ------------------------------------------------------------------
     Combobox: input de texto + lista filtrada.
     Mantiene sincronizado un <select> oculto para que el formulario y
     los lectores de pantalla sigan viendo un control estandar.
     ------------------------------------------------------------------ */
  function Combobox(wrap, opts) {
    var input   = wrap.querySelector('[data-cst-input]');
    var listbox = wrap.querySelector('[data-cst-listbox]');
    var native  = wrap.querySelector('select');
    if (!input || !listbox) return null;

    var options = [];        // [{value, count}]
    var visible = [];        // opciones filtradas ahora mismo
    var active  = -1;        // indice resaltado por teclado
    var value   = '';        // valor confirmado
    var open    = false;
    var t = opts.t || {};

    /* pairs es [valor, cuenta] o [valor, cuenta, nota].
       La nota (p.ej. la sigla del estado) se muestra pero NO entra en la
       busqueda: escribir "glendale" debe encontrarla igual. */
    function setOptions(pairs, placeholder) {
      options = pairs.map(function (p) {
        return { value: p[0], count: p[1], note: p[2] || '' };
      });
      input.placeholder = placeholder || '';
      value = '';
      input.value = '';
      if (native) {
        native.innerHTML = '<option value=""></option>' + options.map(function (o) {
          return '<option value="' + esc(o.value) + '">' + esc(o.value) + '</option>';
        }).join('');
        native.value = '';
      }
      syncClear();
      closeList();
    }

    function setEnabled(on) {
      input.disabled = !on;
      wrap.classList.toggle('is-disabled', !on);
      if (!on) { value = ''; input.value = ''; syncClear(); closeList(); }
    }

    function renderList(res) {
      visible = res.list;
      active = -1;
      if (!visible.length) {
        listbox.innerHTML = '<li class="cst-cb__empty" role="presentation">' +
          esc(t.noMatchOption || 'No matches') + '</li>';
        listbox.hidden = false;
        open = true;
        input.setAttribute('aria-expanded', 'true');
        wrap.classList.add('is-open');
        return;
      }
      var hint = res.fuzzy
        ? '<li class="cst-cb__hint" role="presentation">' + esc(t.didYouMean || 'Did you mean…') + '</li>'
        : '';
      listbox.innerHTML = hint + visible.map(function (o, i) {
        var note = o.note ? ' <i>' + esc(o.note) + '</i>' : '';
        return '<li class="cst-cb__opt" role="option" id="' + input.id + '-o' + i + '"' +
               ' data-i="' + i + '" aria-selected="false">' +
               '<span>' + esc(o.value) + note + '</span>' +
               '<em>' + o.count + '</em></li>';
      }).join('');
      listbox.hidden = false;
      open = true;
      input.setAttribute('aria-expanded', 'true');
      wrap.classList.add('is-open');
    }

    function openList(query) {
      if (input.disabled) return;
      /* `plain`: campo de texto sin desplegable (lo usa el ZIP desde que
         busca por proximidad — sugerir solo los 154 codigos con tienda
         daba a entender que los demas no valen). El resto del componente
         sigue igual: valor, boton de limpiar, onChange. */
      if (opts.plain) return;
      renderList(searchOptions(query === undefined ? '' : query, options));
    }

    /* is-open en .cst-select (el wrapper, mismo patron que is-disabled)
       rota la flecha del chevron mientras la lista esta abierta, incluso
       sin ningun valor elegido — feedback visual de que el campo esta
       activo. Independiente de is-filled en .cst-cb__clear (que indica
       "hay un valor, tocar limpia"): ambas clases pueden convivir. */
    function closeList() {
      listbox.hidden = true;
      listbox.innerHTML = '';
      open = false;
      active = -1;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      wrap.classList.remove('is-open');
    }

    function highlight(i) {
      var items = listbox.querySelectorAll('.cst-cb__opt');
      if (!items.length) return;
      if (i < 0) i = items.length - 1;
      if (i >= items.length) i = 0;
      active = i;
      for (var k = 0; k < items.length; k++) {
        var on = k === i;
        items[k].classList.toggle('is-active', on);
        items[k].setAttribute('aria-selected', on ? 'true' : 'false');
        if (on) {
          input.setAttribute('aria-activedescendant', items[k].id);
          var top = items[k].offsetTop, h = items[k].offsetHeight;
          if (top < listbox.scrollTop) listbox.scrollTop = top;
          else if (top + h > listbox.scrollTop + listbox.clientHeight) {
            listbox.scrollTop = top + h - listbox.clientHeight;
          }
        }
      }
    }

    /* Chevron/boton unico: siempre visible. Sin valor elegido es solo el
       indicador de "desplegable" (el toque lo maneja el input, que abre
       la lista). Con un valor elegido se vuelve boton de limpiar: la
       flecha gira hacia arriba y el mismo toque borra ese paso (y en
       cascada los siguientes) en vez de abrir la lista. */
    var clearBtn = wrap.querySelector('[data-cst-clear-field]');
    /* Etiqueta original del boton, para restaurarla cuando deja de estar
       en estado "confirmar" (ver syncClear). */
    var baseClearLabel = clearBtn ? clearBtn.getAttribute('aria-label') : '';

    function syncClear() {
      if (!clearBtn) return;
      /* En modo `plain` la X aparece con cualquier texto escrito, esté
         confirmado o no: sin desplegable, el botón es la única forma de
         vaciar el campo con el ratón. En los combobox normales sigue
         dependiendo del valor confirmado, porque ahí el chevron cumple
         su función de abrir la lista mientras no hay selección. */
      var filled = opts.plain ? !!(value || input.value) : !!value;
      clearBtn.classList.toggle('is-filled', filled);

      /* Estado CONFIRMAR (2026-09-09, modo `plain`): hay texto escrito
         pero todavia sin confirmar. El boton se convierte en un circulo
         azul con un check — pulsarlo busca ese ZIP.

         El cliente lo pidio porque salir del campo era enredado: en movil
         hay que acertarle a "Done"/"Go" del teclado o tocar fuera, y el
         chevron de al lado no confirmaba nada. Ahora el gesto obvio
         —tocar el boton que esta junto a lo que acabas de escribir—
         hace lo que se espera.

         `confirmable` es texto escrito != al valor ya confirmado: si
         coinciden, no hay nada que confirmar y el boton vuelve a ser
         limpiar. */
      var typed = (input.value || '').trim();
      var confirmable = !!(opts.plain && typed && typed !== value);
      clearBtn.classList.toggle('is-confirm', confirmable);
      if (confirmable) {
        clearBtn.setAttribute('aria-label', opts.confirmLabel || 'Search this ZIP code');
      } else if (baseClearLabel) {
        clearBtn.setAttribute('aria-label', baseClearLabel);
      }
    }

    if (clearBtn) {
      /* preventDefault en mousedown evita que el boton le robe el foco
         al input. Sin esto, cada click en el chevron dispara un blur
         del input (que cierra la lista con su timeout de 120ms) seguido
         de un focus (que la reabre) — dos eventos async peleando entre
         si, y con clicks sucesivos el orden se desincroniza: la lista
         "se buguea", abriendo y cerrando sola en el click siguiente. */
      clearBtn.addEventListener('mousedown', function (e) { e.preventDefault(); });
      clearBtn.addEventListener('click', function (e) {
        /* En modo `plain` (el ZIP) el boton borra lo que haya ESCRITO,
           aunque no este confirmado. Antes solo actuaba con un `value`
           confirmado: si escribias "918" y no pulsabas Enter, no habia X
           ni lista que abrir — el usuario quedaba sin forma de vaciar el
           campo desde el boton (reportado: "no puedo hacer doble click
           para borrar todo"). */
        /* Estado CONFIRMAR: hay texto sin confirmar, asi que el boton
           BUSCA en vez de borrar. Va antes que la rama de limpiar porque
           ambas se cumplen con texto escrito y sin valor; el orden decide
           cual gana, y confirmar es lo que el usuario espera al pulsar
           un check. Para vaciar el campo sigue estando la X, que reaparece
           en cuanto el ZIP queda confirmado. */
        if (clearBtn.classList.contains('is-confirm')) {
          e.preventDefault();
          e.stopPropagation();
          commit((input.value || '').trim());
          return;
        }
        if (opts.plain && !value && input.value) {
          e.preventDefault();
          e.stopPropagation();
          input.value = '';
          if (native) native.value = '';
          syncClear();
          if (opts.onChange) opts.onChange('');
          input.focus();
          return;
        }
        if (!value) {
          /* Sin valor el chevron es solo decorativo, pero al ser un
             <button> real superpuesto sobre el input, el click nunca
             "atraviesa" hasta el input de abajo — se perdia sin abrir
             la lista. Como el mousedown de arriba ya evito que el input
             pierda el foco, togglear la lista a mano replica el mismo
             comportamiento que clickear el campo directamente (abrir/
             cerrar), sin depender de que el evento focus se re-dispare. */
          if (open) closeList(); else openList(input.value);
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        value = '';
        input.value = '';
        if (native) native.value = '';
        syncClear();
        closeList();
        if (opts.onChange) opts.onChange('');
        input.focus();
      });
    }

    function commit(val) {
      value = val;
      input.value = val;
      if (native) native.value = val;
      syncClear();
      closeList();
      /* blur() baja el teclado virtual en movil al elegir una opcion —
         sin esto, el input seguia enfocado y el teclado tapaba las
         cards recien renderizadas debajo. */
      input.blur();
      /* Se notifica SIEMPRE, aunque el valor ya fuera ese. Con la
         autoconfirmacion por longitud (ver el listener de `input`), al
         llegar al 5o digito el valor ya queda fijado; si commit() se
         saltara el aviso por "no cambio nada", pulsar Enter o el check
         despues no dispararia el scroll a los resultados y el boton
         parecerian no hacer nada. Aqui `auto` va en false a proposito:
         esto SI es el usuario dando por terminada la busqueda. */
      if (opts.onChange) opts.onChange(val, { auto: false });
    }

    input.addEventListener('input', function () {
      // Escribir invalida la seleccion previa hasta que se confirme una
      if (value) {
        value = '';
        if (native) native.value = '';
        if (opts.onChange) opts.onChange('');
      }
      /* syncClear en CADA tecla, no solo al invalidar un valor previo:
         en modo `plain` la X depende del texto escrito, y escribiendo
         desde vacio nunca habria entrado en el `if` de arriba — la X no
         llegaba a aparecer. */
      syncClear();
      openList(input.value);

      /* AUTOCONFIRMAR al completar el codigo (2026-09-09).

         Antes la busqueda solo se disparaba con Enter, al salir del campo
         (blur) o al pulsar el boton. Si el usuario escribia el ZIP y se
         limitaba a hacer SCROLL, el input conservaba el foco —no hay
         blur— y la lista seguia mostrando el estado anterior: 189 tiendas
         de California mientras el campo decia 32311 (Florida). El cliente
         lo reporto en escritorio y en movil.

         Un ZIP de EE.UU. tiene siempre 5 digitos, asi que ese es el
         momento inequivoco de confirmar: no hay ambiguedad sobre si el
         usuario "ya termino de escribir".

         `autoLength` lo activa solo el campo de ZIP. No se usa un debounce
         por tiempo porque dispararia busquedas a medio escribir (con "9",
         "92", "925"...), cada una recalculando distancias de 189 tiendas.

         Ojo: NO se llama a commit() aqui. commit() hace input.blur() para
         bajar el teclado, y perder el foco a mitad de escritura impediria
         corregir el codigo. Se confirma el valor a mano y se deja el foco
         intacto — el usuario sigue pudiendo editar. */
      if (opts.autoLength) {
        var typedNow = (input.value || '').trim();
        if (typedNow.length === opts.autoLength && typedNow !== value) {
          value = typedNow;
          if (native) native.value = typedNow;
          syncClear();
          closeList();
          /* El flag `auto` avisa a zipChosen de que esto lo disparo el
             teclado, no el usuario dando por terminada la busqueda: la
             lista se actualiza pero la pagina no se mueve. */
          if (opts.onChange) opts.onChange(typedNow, { auto: true });
        }
      }
    });

    /* Al enfocar con una opcion ya elegida se abre la lista COMPLETA, no
       filtrada por el valor actual: si no, "California" solo se filtraria a
       si misma y habria que borrar a mano para poder cambiar de estado.
       El texto se selecciona para que escribir lo reemplace de una vez. */
    input.addEventListener('focus', function () {
      if (value) {
        openList('');
        input.select();
      } else {
        openList(input.value);
      }
    });

    /* Un clic sobre el input ya enfocado tambien reabre la lista completa:
       en movil el focus no siempre se vuelve a disparar. */
    input.addEventListener('click', function () {
      if (!open) { openList(value ? '' : input.value); if (value) input.select(); }
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        if (!open) openList(input.value); else highlight(active + 1);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (open) highlight(active - 1);
      } else if (e.key === 'Enter') {
        if (open && active > -1 && visible[active]) {
          e.preventDefault();
          commit(visible[active].value);
        } else if (open && visible.length === 1) {
          // Un solo resultado: Enter lo acepta aunque no este resaltado
          e.preventDefault();
          commit(visible[0].value);
        } else if (opts.freeText && input.value.trim()) {
          /* Escritura libre (solo el campo de ZIP): Enter acepta lo
             tecleado aunque no coincida con ninguna opcion. Es lo que
             permite buscar un codigo postal SIN tienda y aun asi ver las
             mas cercanas — antes ese texto se descartaba y no pasaba
             nada. Los combobox de estado y ciudad no llevan freeText:
             ahi un valor inventado no puede filtrar nada. */
          e.preventDefault();
          commit(input.value.trim());
        }
      } else if (e.key === 'Escape') {
        input.value = value;      // vuelve a lo confirmado
        closeList();
      } else if (e.key === 'Tab') {
        closeList();
      }
    });

    // mousedown, no click: el blur del input no debe cerrar antes de elegir
    listbox.addEventListener('mousedown', function (e) {
      var li = e.target.closest('.cst-cb__opt');
      if (!li) return;
      e.preventDefault();
      var i = parseInt(li.getAttribute('data-i'), 10);
      if (visible[i]) commit(visible[i].value);
    });

    input.addEventListener('blur', function () {
      // Si quedo texto sin confirmar, lo revierto: el filtro nunca queda
      // en un estado ambiguo por un tipeo a medias.
      setTimeout(function () {
        /* Con escritura libre (ZIP), salir del campo CONFIRMA lo escrito
           en vez de borrarlo: mucha gente escribe el codigo y hace clic
           fuera sin pulsar Enter, y revertir ahi hacia sentir que el
           buscador ignora lo que escribes. */
        if (opts.freeText) {
          var typed = input.value.trim();
          if (typed && typed !== value) { commit(typed); return; }
          /* Ya autoconfirmado por longitud: el valor coincide, asi que el
             `if` de arriba no entra. Aun asi hay que pasar por commit()
             para que salir del campo cuente como "termine de buscar" y
             baje a los resultados — sin esto, escribir el ZIP y tocar
             fuera actualizaba la lista pero dejaba al usuario arriba. */
          if (typed && typed === value) { commit(typed); return; }
        }
        if (!open) { input.value = value; return; }
        input.value = value;
        closeList();
      }, 120);
    });

    syncClear();

    return {
      setOptions: setOptions,
      setEnabled: setEnabled,
      getValue: function () { return value; },
      /* Fija el valor sin disparar onChange: lo usa el relleno automatico
         al elegir un ZIP, para no encadenar renders redundantes. */
      setValue: function (val) {
        value = val;
        input.value = val;
        if (native) native.value = val;
        syncClear();
        closeList();
      },
      clear: function () {
        value = ''; input.value = '';
        if (native) native.value = '';
        syncClear(); closeList();
      }
    };
  }

  /* ------------------------------------------------------------------
     Card
     ------------------------------------------------------------------ */
  /* Direccion postal, sin nombre. Es la que se muestra en la card. */
  function fullAddress(s) { return s.address + ', ' + s.city + ', ' + s.state + ' ' + s.zip; }

  /* Destino para navegacion: NOMBRE DEL NEGOCIO + direccion.
     Con la direccion sola, Google y Waze resuelven un punto postal en la
     calle (el pin cae en el parking o en la acera de enfrente). Anteponer
     el nombre hace que resuelvan el negocio real y su entrada. */
  function navDestination(s) {
    return (s.chain ? s.chain + ', ' : '') + fullAddress(s);
  }
  function mapsUrl(s) {
    return 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(navDestination(s));
  }
  function wazeUrl(s) {
    return 'https://waze.com/ul?q=' + encodeURIComponent(navDestination(s)) + '&navigate=yes';
  }

  function injectDefs() {
    if (document.getElementById('cst-defs')) return;
    var holder = document.createElement('div');
    holder.innerHTML =
      '<svg id="cst-defs" width="0" height="0" style="position:absolute" aria-hidden="true"><defs>' +
        '<symbol id="cst-star" viewBox="0 0 24 24">' +
          '<path d="M12 1c.85 6.4 3.75 9.3 10.15 10.15C15.75 12 12.85 14.9 12 21.3c-.85-6.4-3.75-9.3-10.15-10.15C8.25 10.3 11.15 7.4 12 1Z"/>' +
        '</symbol>' +
        '<symbol id="cst-note" viewBox="0 0 24 24">' +
          '<path d="M12.45 23.01L10.50 23.01L9.66 22.73L8.27 21.67L7.35 19.80L7.21 19.14L7.76 17.28L8.86 15.88L10.41 15.11L10.60 14.83L10.40 14.58L10.65 14.08L9.01 12.00L8.01 9.95L7.70 8.92L7.74 5.52L8.05 5.15L8.39 5.10L9.70 5.70L10.98 5.99L12.45 5.98L13.84 5.65L15.89 4.48L17.23 2.97L18.01 1.52L18.41 1.43L18.62 1.61L18.73 2.14L18.70 4.94L18.24 7.33L17.70 8.42L16.45 9.95L14.75 10.76L14.64 10.95L14.33 10.90L13.72 11.24L12.67 11.04L12.82 11.20L12.55 11.54L12.41 11.45L12.51 11.06L12.26 11.08L12.32 11.34L11.99 12.16L12.27 12.80L12.73 13.31L12.76 13.69L13.29 14.48L13.55 14.77L13.82 14.80L14.01 15.27L15.15 16.56L15.70 17.83L15.79 18.72L15.62 20.02L14.73 21.70L13.75 22.46L12.45 23.01Z"/>' +
        '</symbol>' +
        '<symbol id="cst-leaf" viewBox="0 0 24 24"><g transform="translate(12 18)">' +
          '<path d="M0 0c-2.2-2.6-3-5.4-2.3-8.4.35-1.6 2.6-1.6 2.95 0C1.35-5.4.9-2.6 0 0Z" transform="rotate(-52) scale(.92)"/>' +
          '<path d="M0 0c-2.2-2.6-3-5.4-2.3-8.4.35-1.6 2.6-1.6 2.95 0C1.35-5.4.9-2.6 0 0Z" transform="rotate(-17) scale(1.06)"/>' +
          '<path d="M0 0c-2.2-2.6-3-5.4-2.3-8.4.35-1.6 2.6-1.6 2.95 0C1.35-5.4.9-2.6 0 0Z" transform="rotate(17) scale(1.02)"/>' +
          '<path d="M0 0c-2.2-2.6-3-5.4-2.3-8.4.35-1.6 2.6-1.6 2.95 0C1.35-5.4.9-2.6 0 0Z" transform="rotate(50) scale(.86)"/>' +
          '<circle cx="0" cy="-1.4" r="2.6"/>' +
        '</g></symbol>' +
      '</defs></svg>';
    document.body.appendChild(holder.firstChild);
  }

  /* Adornos sueltos de la card (calcados del Figma, nodo 183:8877): nota
     verde y estrellas junto al logo, estrella junto al telefono, figura
     junto a "Find Us", puntito rosa junto a los botones. Requiere
     window.CST_CARD_DECO (definido en el .liquid via asset_url) —
     si no esta disponible, no pinta nada en vez de romper. */
  function confetti() {
    if (!window.CST_CARD_DECO) return '';
    var d = window.CST_CARD_DECO;
    return '<div class="cst-card__deco" aria-hidden="true">' +
      '<img class="cst-card__deco-i cst-card__deco-i--note" src="' + esc(d.note) + '" alt="">' +
      '<img class="cst-card__deco-i cst-card__deco-i--star-lg" src="' + esc(d.starLg) + '" alt="">' +
      '<img class="cst-card__deco-i cst-card__deco-i--star-tel" src="' + esc(d.starTel) + '" alt="">' +
      '<img class="cst-card__deco-i cst-card__deco-i--star-findus" src="' + esc(d.starTel) + '" alt="">' +
      '<img class="cst-card__deco-i cst-card__deco-i--decor" src="' + esc(d.decor) + '" alt="">' +
      '<img class="cst-card__deco-i cst-card__deco-i--dot" src="' + esc(d.dot) + '" alt="">' +
    '</div>';
  }

  /* ------------------------------------------------------------------
     Street View
     Los terminos de Google prohiben almacenar o cachear sus imagenes:
     se cargan en vivo desde sus servidores. La key va restringida por
     dominio en Google Cloud, asi que verla en el HTML no permite usarla
     en otro sitio.

     El endpoint /metadata es GRATIS y dice si existe foto para esa
     direccion. Se consulta primero para no pedir (ni pagar) imagenes
     que no existen, y para poder caer a la foto de cadena cuando no hay.
     ------------------------------------------------------------------ */
  function streetViewUrl(store, cfg) {
    return 'https://maps.googleapis.com/maps/api/streetview' +
      '?size=' + (cfg.svSize || '640x274') +
      '&location=' + encodeURIComponent(fullAddress(store)) +
      '&fov=' + (cfg.svFov || 80) +
      '&pitch=' + (cfg.svPitch || 5) +
      '&source=outdoor' +
      '&key=' + encodeURIComponent(cfg.svKey);
  }

  function streetViewMetaUrl(store, cfg) {
    return 'https://maps.googleapis.com/maps/api/streetview/metadata' +
      '?location=' + encodeURIComponent(fullAddress(store)) +
      '&source=outdoor' +
      '&key=' + encodeURIComponent(cfg.svKey);
  }

  /* Resuelve la foto de una card ya renderizada.
     Solo se llama cuando la card entra en pantalla (IntersectionObserver),
     de modo que una lista larga no dispara decenas de peticiones de golpe. */
  function resolveStreetView(figure, store, cfg) {
    if (!cfg.svKey) return;

    fetch(streetViewMetaUrl(store, cfg))
      .then(function (r) { return r.json(); })
      .then(function (meta) {
        if (!meta || meta.status !== 'OK') return;   // sin foto: se queda el respaldo
        var img = new Image();
        img.onload = function () {
          figure.classList.remove('cst-card__photo--empty');
          figure.innerHTML = '';
          img.alt = store.name;
          figure.appendChild(img);
        };
        img.decoding = 'async';
        img.src = streetViewUrl(store, cfg);
      })
      .catch(function () { /* red caida: se queda el respaldo */ });
  }

  /* Un solo observer para toda la pagina: mas barato que uno por card */
  var svObserver = null;
  function observeStreetView(root, cfg) {
    if (!cfg.svKey || !('IntersectionObserver' in window)) return;
    if (svObserver) svObserver.disconnect();
    svObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        svObserver.unobserve(en.target);
        var s = en.target.__cstStore;
        if (s) resolveStreetView(en.target, s, cfg);
      });
    }, { rootMargin: '200px' });   // arranca un poco antes de ser visible

    root.querySelectorAll('[data-cst-sv]').forEach(function (fig) {
      svObserver.observe(fig);
    });
  }

  /* ------------------------------------------------------------------
     Identidad estable de tienda

     El JSON del Liquid no trae el handle, y el nombre no es unico: hay
     cadenas con varias sucursales del mismo nombre en la misma ciudad.
     Se marca cada objeto una sola vez con un entero incremental, que
     sobrevive a los re-renders porque vive en el propio objeto.
     ------------------------------------------------------------------ */
  var uidSeq = 0;
  function storeUid(s) {
    if (s.__cstUid == null) s.__cstUid = ++uidSeq;
    return s.__cstUid;
  }

  /* ------------------------------------------------------------------
     Mapa (Leaflet)

     Mejora progresiva: si Leaflet no cargo, si el navegador no lo
     soporta o si ninguna tienda tiene coordenadas, esta rama entera no
     se ejecuta y la lista sigue funcionando igual que siempre.
     ------------------------------------------------------------------ */

  function hasCoords(s) {
    return typeof s.lat === 'number' && typeof s.lon === 'number' &&
           isFinite(s.lat) && isFinite(s.lon);
  }

  /* Las 5 tiendas cuya direccion no resolvio ni corrigiendola: su pin cae
     en el centroide del codigo postal, a unas cuadras del sitio real.

     Se listan aqui y no en un campo del metaobject porque son 5 casos
     cerrados de un dato derivado de la geocodificacion, no un atributo
     que el cliente deba mantener: anadir un tercer campo al admin obliga
     a explicarlo y a rellenarlo en cada alta. Se identifican por
     nombre+ZIP, ambos ya presentes en el JSON y estables.

     Si se corrige la direccion en el admin y se vuelve a geocodificar,
     hay que quitar la entrada de esta lista. Ver docs/GEOCODIFICACION.md */
  var APPROX_PINS = {
    'El Super #03|90022': 1,
    'Cardenas #17|92201': 1,
    'Northgate González #24|90744': 1,
    'Cardenas #81|91761': 1,
    'Cardenas #207|94565': 1
  };
  function isApprox(s) {
    return !!APPROX_PINS[(s.name || '') + '|' + (s.zip || '')];
  }

  function StoreMap(root, cfg, handlers) {
    if (!window.L) return null;

    var mapEl = root.querySelector('[data-cst-map]');
    var wrap  = root.querySelector('[data-cst-mapwrap]');
    if (!mapEl || !wrap) return null;

    var map = null;
    var layer = null;
    var markers = {};      // uid -> marker
    var activeUid = null;

    /* Encuadre del mapa cuando no hay pines que mostrar (estado inicial).

       El centro es el punto medio real de las 189 tiendas (33.9, -101.3),
       calculado sobre sus coordenadas: van de California a Florida, 42
       grados de longitud. Un zoom que abarcara ese ancho completo
       mostraria medio continente —incluida Sudamerica, que es justo lo
       que se veia antes—, asi que se usa 4: encuadra el sur de EE.UU.,
       la franja donde esta la marca, sin irse de escala. */
    var EMPTY_VIEW = { center: [33.9, -101.3], zoom: 4 };

    /* Leaflet mide el contenedor al crearse. Si se instancia mientras el
       aside esta `hidden` toma 0x0 y el mapa sale gris: por eso se crea
       en el primer show() real, no aqui. */
    function ensure() {
      if (map) return map;
      map = L.map(mapEl, {
        scrollWheelZoom: false,   // se habilita al entrar (ver mas abajo)
        zoomControl: true,
        attributionControl: true,
        /* Pellizco de dos dedos en movil. Sin esto el mapa no hace zoom
           tactil, que era justo lo que fallaba. `touchZoom` solo, sin
           dragging, dejaria hacer zoom pero no desplazar el mapa. */
        touchZoom: true,
        dragging: true,
        tap: true
      });
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      }).addTo(map);
      layer = L.layerGroup().addTo(map);

      /* Zoom con rueda: activo mientras el cursor esta DENTRO del mapa.

         Antes se usaba map.on('mouseout'), y ahi estaba el fallo: en
         Leaflet ese evento salta tambien al pasar el cursor sobre un pin
         o sobre los botones +/- (son hijos del contenedor), asi que el
         zoom se apagaba constantemente y parecia que no funcionaba.

         Los listeners van sobre el elemento del DOM con mouseenter /
         mouseleave, que NO burbujean desde los hijos. */
      mapEl.addEventListener('mouseenter', function () {
        map.scrollWheelZoom.enable();
      });
      mapEl.addEventListener('mouseleave', function () {
        map.scrollWheelZoom.disable();
      });
      return map;
    }

    function pinHTML(s) {
      var logo = chainLogoFor(s);
      var cls = 'cst-pin' + (isApprox(s) ? ' cst-pin--approx' : '');
      return '<div class="' + cls + '" data-cst-uid="' + storeUid(s) + '">' +
        (logo
          ? '<img src="' + esc(logo) + '" alt="" aria-hidden="true">'
          : '<span class="cst-pin__txt">' + esc((s.chain || '?').slice(0, 2).toUpperCase()) + '</span>') +
        '</div>';
    }

    function popupHTML(s) {
      var approx = isApprox(s)
        ? '<span class="cst-pop__approx">' + esc(cfg.t.approxNote || 'Approximate location') + '</span>'
        : '';
      var waze = window.CST_WAZE_ICON
        ? '<img src="' + esc(window.CST_WAZE_ICON) + '" alt="">' : '';
      var maps = window.CST_MAPS_ICON
        ? '<img src="' + esc(window.CST_MAPS_ICON) + '" alt="">' : '';

      return '<div class="cst-pop">' +
        '<p class="cst-pop__chain">' + esc(s.chain) + '</p>' +
        '<p class="cst-pop__addr">' + esc(s.address) + '<br>' +
          esc(s.city) + ', ' + esc(s.state) + ' ' + esc(s.zip) + approx + '</p>' +
        '<div class="cst-pop__acts">' +
          '<a class="cst-pop__btn cst-pop__btn--waze" href="' + wazeUrl(s) +
            '" target="_blank" rel="noopener">' + waze + 'Waze</a>' +
          '<a class="cst-pop__btn cst-pop__btn--maps" href="' + mapsUrl(s) +
            '" target="_blank" rel="noopener">' + maps + 'Maps</a>' +
        '</div>' +
      '</div>';
    }

    /* Pinta los pines de las tiendas visibles y encuadra el mapa sobre
       ellas. Se llama en cada render(), asi el mapa siempre refleja
       exactamente lo que muestra la lista. */
    function show(hits, focusOn) {
      var pts = (hits || []).filter(hasCoords);

      /* Lista vacia: el mapa se queda VISIBLE pero sin pines. Antes se
         ocultaba (`wrap.hidden = true`), lo que al entrar a la pagina
         —donde ya no se pintan pines a proposito— habria hecho
         desaparecer el mapa entero.

         Se limpian los marcadores y se encuadra la zona de la marca, de
         modo que el mapa se ve util y ubicado en vez de en blanco. */
      if (!pts.length) {
        wrap.hidden = false;
        ensure();
        /* setView ANTES de invalidateSize: `L.map()` se crea sin centro
           ni zoom (ver ensure()), y Leaflet lanza "Set map center and
           zoom first" si se le pide cualquier operacion de tamano
           mientras no tiene vista. */
        map.setView(EMPTY_VIEW.center, EMPTY_VIEW.zoom);

        /* invalidateSize DIFERIDO, no en el mismo ciclo.

           `wrap.hidden = false` de arriba no surte efecto hasta que el
           navegador recalcula el layout, asi que medir aqui mismo da un
           tamano de 0 y Leaflet pinta las tiles sueltas y descolocadas
           en vez de un mapa continuo (reportado por el cliente).

           requestAnimationFrame espera a ese recalculo. El guard `map`
           protege de que la seccion se haya recargado entre medias. */
        requestAnimationFrame(function () {
          if (map) map.invalidateSize();
        });

        if (layer) layer.clearLayers();
        markers = {};
        activeUid = null;
        return;
      }

      wrap.hidden = false;
      ensure();
      /* El contenedor pudo cambiar de tamano mientras estaba oculto
         (o al abrirse en movil): sin esto Leaflet dibuja las tiles
         desplazadas respecto al area visible.

         Se llama DOS veces a proposito: la inmediata cubre el caso
         normal (el contenedor ya tenia su tamano), y la diferida cubre
         el caso en que `wrap.hidden = false` de la linea de arriba
         acabe de revelarlo — ahi el navegador todavia no ha recalculado
         el layout y medir da 0, que es lo que produce las tiles sueltas
         y descolocadas. */
      map.invalidateSize();
      requestAnimationFrame(function () {
        if (map) map.invalidateSize();
      });

      layer.clearLayers();
      markers = {};
      activeUid = null;

      var bounds = [];
      pts.forEach(function (s) {
        var uid = storeUid(s);
        var m = L.marker([s.lat, s.lon], {
          icon: L.divIcon({
            html: pinHTML(s),
            className: '',          // sin la clase por defecto de Leaflet
            iconSize: [38, 38],
            iconAnchor: [19, 19],
            popupAnchor: [0, -20]
          }),
          title: s.chain + ' — ' + s.address,
          riseOnHover: true
        });
        /* autoPan es la red de seguridad de Leaflet: reencuadra si el
           popup no cabe. Se deja activo para movil, donde el contenedor
           es bajo, pero con margen generoso arriba (60px) para que NO
           compita con el desplazamiento que ya aplica focus(): sin ese
           margen, ambos movian el mapa y se veia un doble salto. */
        m.bindPopup(popupHTML(s), {
          autoPan: true,
          autoPanPaddingTopLeft: [24, 60],
          autoPanPaddingBottomRight: [24, 24],
          closeButton: true
        });
        m.on('click', function () {
          setActive(uid);
          if (handlers.onPick) handlers.onPick(uid);
        });
        m.addTo(layer);
        markers[uid] = m;
        bounds.push([s.lat, s.lon]);
      });

      /* `focusOn` (opcional): coordenada a la que acercarse en vez de
         encuadrar todos los pines. Lo usa la busqueda por ZIP cuando ese
         codigo tiene tienda propia — sin esto, buscar 32822 encuadraba
         las 9 tiendas de Florida y la tienda buscada quedaba perdida
         entre ellas. Pedido del cliente: "que se haga mas zoom a la
         tienda que esta en ese zipcode". */
      if (focusOn) {
        map.setView([focusOn.lat, focusOn.lon], focusOn.zoom || 13);
      } else if (bounds.length === 1) {
        map.setView(bounds[0], 14);
      } else {
        map.fitBounds(bounds, { padding: [38, 38], maxZoom: 15 });
      }
    }

    function setActive(uid) {
      Object.keys(markers).forEach(function (k) {
        var el = markers[k].getElement();
        if (!el) return;
        var pin = el.querySelector('.cst-pin');
        if (pin) pin.classList.toggle('is-active', String(k) === String(uid));
      });
      activeUid = uid;
    }

    /* Card -> mapa: centra el pin y abre su popup.

       Solo hace zoom si el mapa esta MUY alejado (nivel < 12). Antes
       forzaba 14 siempre, lo que al tocar una card desde una vista ya
       cercana daba un salto brusco sin motivo. */
    function focus(uid) {
      var m = markers[uid];
      if (!m || !map) return;
      setActive(uid);

      /* El popup crece HACIA ARRIBA desde el pin (~150px de alto). Si el
         pin se centra en el mapa, el popup ocupa toda la mitad superior y
         la tienda queda visualmente empujada abajo, medio tapada
         (reportado por el cliente: "queda la tienda muy abajo").

         Se desplaza el centro hacia abajo la mitad del alto del popup,
         asi el conjunto pin+popup queda centrado en vez del pin solo.
         `project`/`unproject` convierten a pixeles de pantalla, se aplica
         el offset y se vuelve a coordenadas — es la forma correcta de
         desplazar un centro en Leaflet, porque el equivalente en grados
         cambia con la latitud y el nivel de zoom. */
      var targetZoom = map.getZoom() < 12 ? 13 : map.getZoom();

      /* El popup abre HACIA ARRIBA (popupAnchor [0,-20]), asi que el pin
         tiene que quedar por DEBAJO del centro para que el globo ocupe el
         espacio libre de arriba. Eso se logra restando en Y: el centro
         del mapa sube y el pin baja respecto a el.

         El valor es la mitad del alto del popup (~150px), no el alto
         entero: con 80px el pin bajaba tanto que se salia del encuadre
         (reportado: "ahora queda mas abajo"). Con 45 el conjunto
         pin+popup queda centrado de verdad.

         Verificado con la proyeccion Web Mercator: a zoom 13, restar 45px
         mueve el centro ~0.0065 grados al norte — el pin cae poco mas de
         un tercio de pantalla bajo el centro, con el popup encajando
         justo encima sin tocar el borde superior. */
      var POPUP_OFFSET_PX = 45;

      var pt = map.project(m.getLatLng(), targetZoom);
      pt.y -= POPUP_OFFSET_PX;
      var shifted = map.unproject(pt, targetZoom);

      if (map.getZoom() < 12) map.setView(shifted, targetZoom, { animate: true });
      else map.panTo(shifted, { animate: true });

      /* El popup se abre DESPUES del desplazamiento. Leaflet trae su
         propio `autoPan` que reencuadraria por su cuenta si el popup no
         cupiera — con el offset ya aplicado no le hace falta, y dejarlo
         actuar encima daria un segundo salto. */
      m.openPopup();
    }

    /* Como focus(), pero mas suave: resalta y centra el pin sin abrir el
       popup ni forzar zoom. Es lo que usa el carrusel al deslizar —
       abrir un popup en cada card de paso seria ruidoso. */
    function pan(uid) {
      var m = markers[uid];
      if (!m || !map) return;
      setActive(uid);
      map.panTo(m.getLatLng(), { animate: true, duration: .4 });
    }

    return {
      show: show,
      focus: focus,
      pan: pan,
      has: function (uid) { return !!markers[uid]; },
      refresh: function () { if (map) map.invalidateSize(); }
    };
  }

  /* Card compacta, estilo Walmart Store Finder (rediseño 2026-09-02).

     El cliente pidió pasar de la card grande de marca —con foto, adornos,
     confeti y onda— a una fila densa: nombre, dirección, teléfono y los
     dos botones de navegación. Así caben muchas más tiendas sin scroll,
     que es el punto del buscador.

     El diseño anterior está guardado íntegro en shopify-v1-cards-backup/
     por si hay que volver o reutilizar piezas.

     Se conserva el logo de la cadena: es lo que permite reconocer el
     súper de un vistazo, y era el mayor acierto de la card anterior. */
  function cardHTML(store, cfg) {
    var chainLogoSrc = chainLogoFor(store);
    var logo = chainLogoSrc
      ? '<img class="cst-card__logo" src="' + esc(chainLogoSrc) + '" alt="' +
        esc(store.chain) + '" loading="lazy">'
      : '';

    var tel = store.phone
      ? '<a class="cst-card__tel" href="tel:' + esc(store.phone.replace(/\D/g, '')) + '">' +
          esc(store.phone) +
        '</a>'
      : '';

    /* Distancia: solo aparece si la busqueda tiene un punto de origen
       (ZIP escrito o geolocalizacion). Es lo que hace legible el orden
       por proximidad — sin el numero, una lista ordenada por distancia
       parece arbitraria.

       Menos de una milla se muestra con un decimal ("0.4 mi"); a partir
       de ahi, redondeado ("3 mi"): la precision decimal en distancias
       largas es ruido, nadie decide por 0.2 millas a 12 de camino. */
    var dist = '';
    if (typeof store.__dist === 'number' && isFinite(store.__dist)) {
      var d = store.__dist;
      var shown = d < 1 ? d.toFixed(1) : Math.round(d);
      dist = '<span class="cst-card__dist">' + shown + ' ' +
             esc(cfg.t.milesShort || 'mi') + '</span>';
    }

    /* Los iconos de Waze y Maps son los mismos assets que usaba la card
       grande; aquí van más pequeños, dentro de un botón de una sola
       línea. Los enlaces siguen abriendo en modo "cómo llegar". */
    return '<article class="cst-card" data-cst-uid="' + storeUid(store) + '">' +
      '<div class="cst-card__head">' + logo +
        '<h3 class="cst-card__name">' + esc(store.name || store.chain) + '</h3>' +
        dist +
      '</div>' +
      '<p class="cst-card__addr">' +
        esc(store.address) + '<br>' +
        '<span>' + esc(store.city) + ', ' + esc(store.state) + ' ' + esc(store.zip) + '</span>' +
      '</p>' + tel +
      '<div class="cst-card__acts">' +
        '<a class="cst-btn cst-btn--waze" href="' + wazeUrl(store) + '" target="_blank" rel="noopener">' +
          '<span class="cst-btn__logo">' + ICON.waze + '</span>Waze' +
        '</a>' +
        '<a class="cst-btn cst-btn--maps" href="' + mapsUrl(store) + '" target="_blank" rel="noopener">' +
          '<span class="cst-btn__logo">' + ICON.maps + '</span>Maps' +
        '</a>' +
      '</div>' +
    '</article>';
  }

  /* ------------------------------------------------------------------
     Instancia del locator
     ------------------------------------------------------------------ */
  function Locator(root) {
    if (root.dataset.cstReady === '1') return;

    var dataEl = root.querySelector('[data-cst-data]');
    if (!dataEl) return;

    var payload;
    try { payload = JSON.parse(dataEl.textContent); }
    catch (e) { return; }   // sin datos utilizables dejo el mensaje del servidor

    var stores = payload.stores || [];
    if (!stores.length) return;

    var cfg = {
      logo: payload.logo || '',
      mascot: payload.mascot || '',
      chainPhotos: payload.chain_photos || {},
      cityThreshold: payload.city_threshold || 6,
      /* Street View: sin key, toda la rama queda inerte y las cards
         usan la foto de cadena o el patron de marca. */
      svKey: payload.sv_key || '',
      svSize: payload.sv_size || '640x274',
      svFov: payload.sv_fov || 80,
      svPitch: payload.sv_pitch || 5,
      /* BUG corregido el 2026-09-09: faltaba en esta lista. El Liquid
         emitia "radiusMiles" en el payload, pero `cfg` se construye
         copiando campo por campo y este no se copiaba nunca — asi que
         `cfg.radiusMiles` era undefined y RADIUS_MI caia SIEMPRE al
         respaldo `|| 50`. El ajuste "Search radius" del schema no hacia
         nada; no se noto porque su default tambien era 50. */
      radiusMiles: payload.radiusMiles,
      t: payload.t || {}
    };

    var countEl = root.querySelector('[data-cst-count]');
    var resEl   = root.querySelector('[data-cst-results]');
    var resetEl = root.querySelector('[data-cst-reset]');
    /* Contenedor propio de los chips, fuera de .cst-results: van a ancho
       completo bajo el contador, no dentro de la columna de la lista. */
    var chainsEl = root.querySelector('[data-cst-chains]');
    var helpEl      = root.querySelector('[data-cst-help]');
    var helpTrigger = root.querySelector('[data-cst-help-trigger]');
    var helpLabel   = root.querySelector('[data-cst-help-label]');
    var wState  = root.querySelector('[data-cst-cb="state"]');
    var wCity   = root.querySelector('[data-cst-cb="city"]');
    var wZip    = root.querySelector('[data-cst-cb="zip"]');
    if (!wState || !resEl) return;

    /* Cadena elegida en los chips (ver chipsHTML y current()). Vive fuera
       de render() para sobrevivir a los re-renders; se resetea al cambiar
       de ZIP y cuando esa cadena no existe en la zona buscada. */
    var activeChain = '';

    /* Radio de busqueda en millas, igual que la referencia de Walmart.
       Configurable desde el schema por si el cliente lo quiere mas amplio
       o mas estrecho segun como se comporte con clientes reales. */
    var RADIUS_MI = parseInt(cfg.radiusMiles, 10) || 50;

    /* Si dentro del radio no cae ninguna tienda, se muestran las N mas
       cercanas que existan en vez de una lista vacia. Pocas a proposito:
       son un plan B, no el resultado esperado. */
    var FALLBACK_COUNT = 3;

    /* Cuantas cards se pintan al entrar, antes de que el usuario busque
       nada. 50 es lo que pidio el cliente: suficiente para que la pagina
       se sienta llena y se pueda explorar, sin volcar las 189. */
    var INITIAL_COUNT = 50;

    /* Orden aleatorio de la portada (2026-09-14).

       Se baraja UNA VEZ y se recuerda el resultado: pulsar un chip,
       limpiar el ZIP o volver al estado inicial no debe recolocar las
       cards, o pareceria que la pagina se descontrola. Se rebaraja solo
       al recargar, que es justo lo que pidio el cliente.

       Fisher-Yates sobre una COPIA: `stores` alimenta tambien al mapa y
       a los indices de busqueda, y reordenarlo en sitio los descuadraria.

       El barajado se guarda como un mapa handle -> posicion en vez de
       como una lista de tiendas, para que siga valiendo cuando `hits`
       llega ya filtrado por un chip de cadena. */
    var _ordenAleatorio = null;

    function ordenInicial(lista) {
      if (!_ordenAleatorio) {
        var barajado = stores.slice();
        for (var i = barajado.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var t = barajado[i]; barajado[i] = barajado[j]; barajado[j] = t;
        }
        _ordenAleatorio = {};
        barajado.forEach(function (s, idx) {
          _ordenAleatorio[storeUid(s)] = idx;
        });
      }
      var pos = _ordenAleatorio;
      return lista.slice().sort(function (a, b) {
        return (pos[storeUid(a)] || 0) - (pos[storeUid(b)] || 0);
      });
    }

    /* true cuando se tuvo que recurrir a ese plan B — el contador lo usa
       para no prometer "dentro de 50 millas" cuando no es cierto. */
    var widened = false;


    /* ---------------- Mapa ----------------
       Toda la rama es opcional: si StoreMap devuelve null (sin Leaflet o
       sin contenedor) `smap` queda null y cada uso va guardado. */
    var mapWrap   = root.querySelector('[data-cst-mapwrap]');
    /* Ya no hay botones "View map" / "Hide map": el mapa se muestra
       siempre. Se quitaron del Liquid junto con sus ajustes de texto. */

    /* El mapa esta SIEMPRE visible, tambien en movil (pedido del cliente,
       2026-09-02). Antes iba plegado tras un boton "View map"; ahora en
       movil se muestra arriba y las cards van debajo como carrusel
       horizontal, asi que ambos caben sin empujarse.

       matchMedia se consulta en vivo, no una sola vez, para que girar el
       telefono no deje el estado incoherente. */
    var mqDesktop = window.matchMedia('(min-width:1000px)');

    /* Lleva una card a la vista SIN mover la pagina.

       `scrollIntoView` desplazaba el documento entero: al pulsar un pin
       la pagina saltaba y se perdia de vista el mapa. Aqui se scrollea
       solo el contenedor de la lista —el carrusel en movil, la columna
       con overflow en escritorio— calculando el desplazamiento a mano.

       El eje cambia con el layout: en movil el carrusel es horizontal,
       en escritorio la lista es vertical. */
    function revealCard(card) {
      var box = card.parentElement;            // .cst-cards
      if (!box) return;

      if (mqDesktop.matches) {
        // Vertical: la columna de resultados es la que scrollea
        var sc = resEl;
        var top = card.offsetTop - sc.offsetTop -
                  (sc.clientHeight / 2) + (card.offsetHeight / 2);
        if (sc.scrollTo) sc.scrollTo({ top: top, behavior: 'smooth' });
        else sc.scrollTop = top;
      } else {
        // Horizontal: el carrusel de cards
        var left = card.offsetLeft -
                   (box.clientWidth / 2) + (card.offsetWidth / 2);
        if (box.scrollTo) box.scrollTo({ left: left, behavior: 'smooth' });
        else box.scrollLeft = left;
      }
    }

    /* Lleva la PAGINA a los resultados tras buscar un ZIP (2026-09-09).

       El cliente lo pidio porque al escribir un ZIP los resultados
       quedaban debajo del pliegue y habia que bajar a mano.

       Esto NO contradice la regla de no usar `scrollIntoView` para
       resaltar una card: alli el movimiento era un efecto colateral no
       deseado (pulsar un pin no deberia mover la pagina). Aqui mover la
       pagina ES lo pedido — el usuario acaba de buscar y espera ver el
       resultado.

       Tres cautelas:
       - Solo baja, nunca sube. Si el usuario ya esta viendo los
         resultados, un scroll "de vuelta arriba" seria justo la sacudida
         que se quiso evitar al quitar el scrollIntoView del boton Clear.
       - Descuenta el header sticky de Dawn (--header-height), o el
         contador queda tapado debajo.
       - Respeta prefers-reduced-motion: salta sin animar. */
    function scrollToResults() {
      var anchor = root.querySelector('[data-cst-anchor]');
      if (!anchor) return;

      var headerH = parseInt(
        getComputedStyle(document.documentElement)
          .getPropertyValue('--header-height'), 10) || 0;

      var target = window.pageYOffset +
                   anchor.getBoundingClientRect().top - headerH - 12;

      // Ya esta a la vista (o mas arriba): no mover nada.
      if (target <= window.pageYOffset + 4) return;

      var reduce = window.matchMedia &&
                   window.matchMedia('(prefers-reduced-motion:reduce)').matches;

      if (window.scrollTo && !reduce) {
        try {
          window.scrollTo({ top: target, behavior: 'smooth' });
          return;
        } catch (e) { /* Safari viejo: sin soporte de objeto, cae abajo */ }
      }
      window.scrollTo(0, target);
    }

    var smap = StoreMap(root, cfg, {
      // Pin -> card: resalta la card y la trae a la vista, sin mover la pagina
      onPick: function (uid) {
        var card = resEl.querySelector('[data-cst-uid="' + uid + '"]');
        if (!card) return;
        resEl.querySelectorAll('.cst-card.is-active')
             .forEach(function (c) { c.classList.remove('is-active'); });
        card.classList.add('is-active');
        revealCard(card);
      },
      onEmpty: function () {}
    });

    /* El aside solo se oculta si NO hay ni un pin que enseñar. Ya no
       depende del breakpoint: el mapa se muestra siempre, en movil
       arriba de las cards y en escritorio a la derecha. */
    /* El mapa se muestra SIEMPRE, con o sin pines: sin resultados sigue
       visible y encuadrado en la zona de la marca (ver show()). Antes
       esta funcion lo ocultaba cuando no habia pines, lo que al entrar
       a la pagina —donde ya no se pintan pines a proposito— habria
       hecho desaparecer el mapa entero.

       Se conserva la funcion, y no se borran sus llamadas, porque la
       visibilidad podria volver a depender de algo mas adelante; hoy
       solo garantiza que el aside este visible. */
    function syncMapChrome() {
      if (!smap || !mapWrap) return;
      mapWrap.hidden = false;
    }

    /* Card -> mapa: clic en cualquier parte de la card que no sea un
       enlace (telefono, Waze, Maps) centra su pin. Delegado en el
       contenedor porque las cards se recrean en cada render. */
    resEl.addEventListener('click', function (e) {
      if (!smap) return;
      if (e.target.closest('a,button')) return;   // no robar los CTAs
      var card = e.target.closest('[data-cst-uid]');
      if (!card) return;
      var uid = card.getAttribute('data-cst-uid');

      /* En el estado inicial el mapa esta vacio a proposito, asi que la
         tienda de esta card AUN NO TIENE PIN. Antes se hacia
         `if (!smap.has(uid)) return` y el clic no hacia nada — el
         cliente lo reporto: "le doy click a una card y no me hace la
         ubicacion".

         Si falta el pin, se pinta solo el de esa tienda antes de
         enfocarlo: el mapa pasa de vacio a mostrar justo la que se
         acaba de tocar, que es lo que el usuario esta pidiendo ver. */
      if (!smap.has(uid)) {
        var target = null;
        for (var i = 0; i < stores.length; i++) {
          if (String(storeUid(stores[i])) === String(uid) && hasCoords(stores[i])) {
            target = stores[i];
            break;
          }
        }
        if (!target) return;      // sin coordenadas no hay nada que enfocar
        /* `focusOn` evita el doble salto: sin el, show() encuadraria el
           pin a zoom 14 y focus() lo movería otra vez con su offset —
           dos animaciones seguidas. Pasandolo aqui, el mapa aterriza
           directamente donde tiene que quedar. */
        smap.show([target], { lat: target.lat, lon: target.lon, zoom: 14 });
      }

      resEl.querySelectorAll('.cst-card.is-active')
           .forEach(function (c) { c.classList.remove('is-active'); });
      card.classList.add('is-active');
      smap.focus(uid);

      /* Centra en el carrusel la card que se acaba de tocar (2026-09-09).

         En movil las cards vecinas asoman por los lados y son clicables,
         pero al tocarlas se quedaban donde estaban: se marcaban como
         activas a medio salir de la pantalla. `revealCard` ya sabia
         centrarlas —se usaba para el camino inverso, pin del mapa ->
         card— pero nunca se llamaba desde el propio clic.

         En escritorio no molesta: revealCard usa el eje vertical alli, y
         si la card ya se ve entera el navegador no mueve nada. */
      revealCard(card);
    });

    /* Carrusel -> mapa: al parar de deslizar, la card que quedo centrada
       resalta su pin. Es lo que hace que deslizar sirva para explorar y
       no solo para leer.

       Solo en movil: en escritorio la lista es vertical y ya funciona el
       clic. El listener va sobre resEl (estable) porque .cst-cards se
       recrea en cada render.

       El debounce evita disparar un focus() por cada pixel de scroll: se
       espera a que el movimiento pare. */
    var snapTimer = null;
    resEl.addEventListener('scroll', function (e) {
      if (!smap || mqDesktop.matches) return;
      var box = e.target.closest ? e.target.closest('.cst-cards') : null;
      if (!box) return;
      clearTimeout(snapTimer);
      snapTimer = setTimeout(function () {
        var mid = box.scrollLeft + box.clientWidth / 2;
        var best = null, bestDist = Infinity;
        box.querySelectorAll('[data-cst-uid]').forEach(function (c) {
          var d = Math.abs((c.offsetLeft + c.offsetWidth / 2) - mid);
          if (d < bestDist) { bestDist = d; best = c; }
        });
        if (!best) return;
        var uid = best.getAttribute('data-cst-uid');
        if (!smap.has(uid) || best.classList.contains('is-active')) return;
        resEl.querySelectorAll('.cst-card.is-active')
             .forEach(function (c) { c.classList.remove('is-active'); });
        best.classList.add('is-active');
        /* pan() y no focus(): centra el pin sin abrir el popup ni forzar
           zoom. Deslizando se quiere ojear, no aterrizar en una tienda. */
        smap.pan(uid);
      }, 140);
    }, true);   // captura: el evento scroll no burbujea

    /* Al cruzar el breakpoint cambia el layout (carrusel <-> columna) y
       el tamano del contenedor del mapa: hay que remedirlo o Leaflet
       dibuja las tiles desplazadas. */
    var onBreakpoint = function () {
      if (!smap) return;
      smap.refresh();
    };
    if (mqDesktop.addEventListener) mqDesktop.addEventListener('change', onBreakpoint);
    else if (mqDesktop.addListener) mqDesktop.addListener(onBreakpoint);

    function tally(list, key, sortBy) {
      var map = Object.create(null);
      list.forEach(function (s) { map[s[key]] = (map[s[key]] || 0) + 1; });
      var out = Object.keys(map).map(function (k) { return [k, map[k]]; });
      return sortBy === 'count'
        ? out.sort(function (a, b) { return b[1] - a[1]; })
        : out.sort(function (a, b) { return a[0].localeCompare(b[0], 'en'); });
    }

    var cbState, cbCity, cbZip;

    /* La ciudad se puede elegir sin estado: entonces lista las ciudades de
       todo el pais, con su estado entre parentesis para desambiguar
       (hay Glendale en AZ y en CA). */
    function refreshCity(keepValue) {
      if (!cbCity) return;
      var st = cbState.getValue();
      var prev = keepValue ? cbCity.getValue() : '';

      var pool = st ? stores.filter(function (s) { return s.state_name === st; }) : stores;
      var cities = tally(pool, 'city');

      /* Sin estado elegido puede haber nombres repetidos en estados
         distintos (Glendale esta en AZ y en CA). Anado la sigla para que
         el usuario sepa cual es cual. */
      if (!st) {
        var seen = {};
        pool.forEach(function (s) {
          (seen[s.city] = seen[s.city] || {})[s.state] = 1;
        });
        cities = cities.map(function (c) {
          var states = Object.keys(seen[c[0]] || {});
          return states.length === 1 ? [c[0], c[1], states[0]] : [c[0], c[1], null];
        });
      }

      cbCity.setOptions(cities, cfg.t.allCities);
      cbCity.setEnabled(true);

      if (prev && cities.some(function (c) { return c[0] === prev; })) {
        cbCity.setValue(prev);
      }
    }

    /* Elegir ciudad sin estado rellena el estado correspondiente. */
    function cityChosen(city) {
      activeChain = '';
      if (city && !cbState.getValue()) {
        var hit = stores.filter(function (s) { return s.city === city; })[0];
        if (hit) cbState.setValue(hit.state_name);
      }
      refreshZip(true);
      render();
    }

    /* El ZIP NO depende de los pasos anteriores: siempre esta disponible.
       Muchos usuarios saben su codigo postal y no quieren recorrer estado y
       ciudad para llegar a el. Si hay estado o ciudad elegidos, la lista se
       reduce a esos; si no, ofrece los de todo el pais. */
    function refreshZip(keepValue) {
      if (!cbZip) return;
      var st = cbState.getValue();
      var city = cbCity ? cbCity.getValue() : '';
      var prev = keepValue ? cbZip.getValue() : '';

      var pool = stores.filter(function (s) {
        return (!st || s.state_name === st) && (!city || s.city === city);
      });
      var zips = tally(pool, 'zip');

      cbZip.setOptions(zips, cfg.t.allZips);

      /* SIEMPRE habilitado. Antes se deshabilitaba cuando la lista de
         ZIPs con tienda quedaba vacia — coherente con el desplegable,
         pero fatal ahora: el campo acepta cualquier codigo del pais, y
         bloquearlo dejaria al usuario sin poder escribir justo cuando
         mas lo necesita (una zona sin tiendas propias). */
      cbZip.setEnabled(true);

      /* El valor escrito se conserva tal cual. Antes solo se mantenia si
         coincidia con la lista de ZIPs con tienda; con busqueda por
         proximidad eso borraria un codigo perfectamente valido —
         cualquier ZIP de EE.UU. resuelve ahora. */
      if (prev) cbZip.setValue(prev);
    }

    /* Antes, elegir un ZIP rellenaba tambien estado y ciudad para que el
       usuario viera donde estaba. Desde que esos dos filtros son
       invisibles (rediseño 2026-09-02) eso seria una trampa: current()
       los sigue leyendo, asi que un estado fijado sin que nadie lo vea
       vaciaria la lista al buscar despues un ZIP de otro estado, sin
       ninguna pista de por que.

       Los combos ocultos se quedan vacios a proposito: solo alimentan la
       lista de ZIPs. El unico filtro geografico es el codigo postal. */
    function zipChosen(zip, meta) {
      activeChain = '';   // otra zona, otras cadenas

      /* El ZIP escrito define el punto desde el que se mide. Si no se
         puede resolver (campo vacio, o texto que no es un ZIP), se anula
         el origen y la lista vuelve a su estado sin ordenar. */
      originPoint = resolveZip(zip);
      render();

      /* Baja a los resultados. Va despues del render (la lista ya tiene
         su altura final, si no el destino se calcularia sobre el layout
         viejo) y solo con un ZIP escrito: al limpiar el campo, `zip`
         llega vacio y la pagina se queda donde esta.

         EXCEPCION — autoconfirmado (meta.auto): cuando la busqueda se
         dispara sola al teclear el 5o digito, la lista SI se actualiza
         pero la pagina NO se mueve. El teclado sigue abierto y el usuario
         puede estar a punto de corregir un digito: llevarselo a las cards
         en ese momento le quitaria el campo de la vista.

         El scroll se reserva para cuando el usuario indica que termino:
         pulsar el check, Enter, o salir del campo. */
      if (zip && !(meta && meta.auto)) scrollToResults();

      /* Los centroides se cargan en la PRIMERA busqueda, no al abrir la
         pagina: son ~343 KB y quien solo mira el mapa no deberia pagarlos.

         El render de arriba ya ocurrio con lo que hubiera disponible (el
         indice de tiendas propias); cuando el JSON llega se reintenta la
         resolucion. Si el resultado cambia —tipico al buscar un ZIP sin
         tienda, que antes no resolvia— se vuelve a pintar. */
      if (!zip) return;
      loadZipCentroids().then(function () {
        var better = resolveZip(zip);
        if (!better) return;
        var changed = !originPoint ||
                      better.lat !== originPoint.lat ||
                      better.lon !== originPoint.lon;
        if (!changed) return;
        // El usuario pudo cambiar el ZIP mientras cargaba: no pisar lo nuevo
        if (cbZip.getValue() !== zip) return;
        originPoint = better;
        render();
      });
    }

    /* `activeChain` entra aqui y no en el render: asi la lista y el mapa
       se filtran con el mismo criterio sin duplicar logica. Antes el chip
       solo reordenaba la lista y el mapa seguia mostrando todos los
       pines; ahora filtra de verdad, como los chips de Walmart. */
    /* ---------------- Busqueda por proximidad ----------------

       ANTES: el ZIP filtraba por coincidencia EXACTA (s.zip === zip). Si
       escribias un codigo sin tienda no veias nada — aunque hubiera una a
       3 millas en el ZIP de al lado. Con 154 ZIPs con tienda de los
       ~41.000 de EE.UU., el caso normal era no ver nada.

       AHORA: como Walmart. Se resuelve el ZIP escrito a un PUNTO y se
       ordenan todas las tiendas por distancia real a ese punto.

       De donde sale el punto, sin datos externos ni API de pago:
         1. Si el ZIP tiene tienda, se usa su coordenada directamente.
         2. Si no, se busca el ZIP numericamente mas proximo que SI tenga
            tienda y se mide desde ahi. Los ZIP de EE.UU. son
            geograficamente contiguos por rango numerico (los primeros
            digitos son la region), asi que un ZIP cercano en numero suele
            estarlo tambien en el mapa. Es una aproximacion: buena entre
            codigos vecinos, mas floja cuanto mas lejos este el ZIP escrito
            de cualquier tienda — pero siempre mejor que no mostrar nada.

       Si algun dia hace falta precision real en CUALQUIER ZIP del pais,
       la via es una tabla de centroides del censo (~400 KB) — evaluada y
       aplazada, ver §16 de la SPEC. */

    /* Indice ZIP -> coordenada, construido una sola vez sobre las tiendas
       que tienen pin. Se cachea porque `stores` no cambia en toda la vida
       de la pagina. */
    var zipIndex = null;
    function buildZipIndex() {
      if (zipIndex) return zipIndex;
      zipIndex = {};
      stores.forEach(function (s) {
        if (!hasCoords(s) || !s.zip) return;
        // El primero gana: con varias tiendas en un ZIP, cualquiera sirve
        // como referencia del centro de esa zona.
        if (!zipIndex[s.zip]) zipIndex[s.zip] = { lat: s.lat, lon: s.lon };
      });
      return zipIndex;
    }

    /* Centroides reales de los 41.488 codigos postales de EE.UU., datos
       oficiales de GeoNames (CC-BY 3.0 — la atribucion va en el pie de la
       seccion, es obligatoria por licencia). Se cargan BAJO DEMANDA desde
       assets/zip-centroids.json: son ~343 KB comprimidos, y un visitante
       que nunca busca no deberia pagarlos.

       Una primera version derivaba el punto del ZIP mas proximo
       NUMERICAMENTE entre nuestras propias tiendas. Se descarto al
       probarla: 99019 (Spokane, WA) resolvia a una tienda de California
       con "0.0 mi", y 90210 (Beverly Hills) daba 0.0 mi para una tienda
       a 12 millas. Los ZIP vecinos en numero no lo son en el mapa.

       Verificado contra las 188 tiendas: el centroide del ZIP queda a
       1.21 millas (mediana) de la tienda que hay en ese mismo ZIP — la
       dispersion normal de un area postal. */
    var zipCentroids = null;      // null = sin cargar; {} = cargado
    var zipCentroidsLoading = null;

    function loadZipCentroids() {
      if (zipCentroids) return Promise.resolve(zipCentroids);
      if (zipCentroidsLoading) return zipCentroidsLoading;

      var url = (window.CST_ZIP_CENTROIDS_URL || '');
      if (!url || !window.fetch) return Promise.resolve(null);

      zipCentroidsLoading = fetch(url)
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) { zipCentroids = data || {}; return zipCentroids; })
        .catch(function () {
          /* Sin centroides se sigue funcionando: resolveZip cae al indice
             de nuestras tiendas, que cubre los ZIPs donde hay tienda. La
             busqueda por proximidad no se rompe, solo pierde alcance. */
          zipCentroids = {};
          return zipCentroids;
        });
      return zipCentroidsLoading;
    }

    /* Devuelve {lat, lon, exact} para el ZIP escrito, o null si no se
       puede resolver. `exact` distingue el centroide oficial del ZIP
       (true) del respaldo por tienda propia (tambien true: ambos son
       puntos reales, no aproximaciones). */
    function resolveZip(zip) {
      if (!zip) return null;

      /* Centroide oficial: la via principal, cubre CUALQUIER ZIP del
         pais aunque no tengamos ninguna tienda cerca. */
      if (zipCentroids && zipCentroids[zip]) {
        return { lat: zipCentroids[zip][0], lon: zipCentroids[zip][1], exact: true };
      }

      /* Respaldo mientras el JSON aun no llego (o si fallo la descarga):
         si el ZIP tiene tienda, su coordenada sirve de referencia. */
      var idx = buildZipIndex();
      if (idx[zip]) {
        return { lat: idx[zip].lat, lon: idx[zip].lon, exact: true };
      }

      return null;
    }

    /* Punto de referencia activo de la busqueda. Lo fija el ZIP escrito o
       el boton "use my current location"; null = sin busqueda geografica,
       la lista no se ordena por distancia. */
    var originPoint = null;

    function current() {
      var st = cbState.getValue();
      var city = cbCity ? cbCity.getValue() : '';

      var hits = stores.filter(function (s) {
        return (!st || s.state_name === st) &&
               (!city || s.city === city) &&
               (!activeChain || s.chain === activeChain);
      });

      /* Sin punto de origen no hay nada que ordenar: se devuelve el
         filtrado tal cual (es el caso de entrar por State/City, o de
         tocar un chip sin haber buscado antes). */
      if (!originPoint) return hits;

      /* Con origen: se anota la distancia de cada tienda y se ordena de
         mas cerca a mas lejos. Las tiendas SIN coordenadas (una recien
         dada de alta sin lat/lon) no se descartan — van al final, para
         que seguir apareciendo en la lista no dependa de tener pin. */
      hits.forEach(function (s) {
        s.__dist = hasCoords(s)
          ? milesBetween(originPoint.lat, originPoint.lon, s.lat, s.lon)
          : null;
      });

      return hits.slice().sort(function (a, b) {
        if (a.__dist == null && b.__dist == null) return 0;
        if (a.__dist == null) return 1;
        if (b.__dist == null) return -1;
        return a.__dist - b.__dist;
      });
    }

    /* Las tiendas que hay ANTES de aplicar el chip de cadena: son las que
       definen que chips se ofrecen. Si se calcularan sobre `current()`,
       al elegir una cadena desapareceria el resto de chips y no habria
       forma de cambiar de cadena ni de volver atras. */
    function currentNoChain() {
      var st = cbState.getValue();
      var city = cbCity ? cbCity.getValue() : '';

      var pool = stores.filter(function (s) {
        return (!st || s.state_name === st) &&
               (!city || s.city === city);
      });

      /* Con busqueda activa, los chips se calculan sobre las tiendas
         DENTRO DEL RADIO, no sobre todo el pais: ofrecer un chip de una
         cadena que no existe en la zona buscada seria un filtro que solo
         puede dar cero resultados.

         Antes esto filtraba por `s.zip === zip` exacto — un resto del
         filtrado por coincidencia. Al pasar a proximidad, un ZIP sin
         tienda propia dejaba el pool vacio y los chips desaparecian. */
      if (originPoint) {
        var within = pool.filter(function (s) {
          if (!hasCoords(s)) return false;
          return milesBetween(originPoint.lat, originPoint.lon, s.lat, s.lon) <= RADIUS_MI;
        });
        // Nada en el radio: los chips reflejan las que SI se listan
        if (within.length) return within;
      }

      return pool;
    }

    /* Tras pintar, engancho cada figure de foto con su tienda para que
       el IntersectionObserver sepa que direccion consultar. El orden de
       los nodos coincide con el de las tiendas que acabo de renderizar. */
    function bindStreetView(list) {
      if (!cfg.svKey) return;
      var figs = resEl.querySelectorAll('[data-cst-sv]');
      var i = 0;
      list.forEach(function (s) {
        if (s.image) return;              // tiene foto propia: no lleva marcador
        if (figs[i]) figs[i].__cstStore = s;
        i++;
      });
      observeStreetView(resEl, cfg);
    }


    /* Chips de cadena, al estilo de los filtros de Walmart.

       Desde el rediseño de 2026-09-02 FILTRAN de verdad (antes solo
       reordenaban): el filtrado ocurre en current(), así que la lista y
       el mapa quedan siempre con las mismas tiendas.

       Los chips se construyen sobre currentNoChain() — lo que hay antes
       de aplicar el chip — porque si se calcularan sobre el resultado ya
       filtrado, al elegir una cadena desaparecerían los demás chips y no
       habría manera de cambiar de cadena. */
    function chipsHTML() {
      var pool = currentNoChain();
      var chainSet = {};
      pool.forEach(function (s) {
        if (!(s.chain in chainSet)) chainSet[s.chain] = chainLogoFor(s);
      });
      var chains = Object.keys(chainSet).sort(function (a, b) {
        return a.localeCompare(b, 'en');
      });

      /* La cadena activa ya no existe en este ZIP: se descarta sola en
         vez de dejar la lista vacía sin explicación. */
      if (activeChain && chains.indexOf(activeChain) === -1) activeChain = '';

      // Un solo súper en la zona: el chip no ofrece ninguna elección
      if (chains.length < 2) return '';

      return '<div class="cst-chain-filter" data-cst-chain-filter>' +
        chains.map(function (chain) {
          var logo = chainSet[chain];
          var on = chain === activeChain;
          return '<button type="button" class="cst-chain-chip' + (on ? ' is-active' : '') +
            '" data-cst-chain="' + esc(chain) + '" aria-pressed="' + on + '">' +
            (logo ? '<img src="' + esc(logo) + '" alt="' + esc(chain) + '">' : esc(chain)) +
            '</button>';
        }).join('') + '</div>';
    }

    /* Los chips se re-pintan en cada render, así que el listener va
       delegado en su contenedor, que sí es estable. Antes colgaba de
       .cst-results, donde vivían los chips; al moverlos a su propia
       barra bajo el contador, quedarse ahí los habría dejado sin
       respuesta al clic. */
    if (chainsEl) {
      chainsEl.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-cst-chain]');
        if (!btn) return;
        var chain = btn.getAttribute('data-cst-chain');
        activeChain = (activeChain === chain) ? '' : chain;
        render();
      });
    }

    /* render() sincroniza lista y mapa. renderResults() pinta y devuelve
       lo que quedó en pantalla; este wrapper alimenta el mapa con ese
       mismo array, de modo que no puedan desincronizarse. */
    function render() {
      var shown = renderResults();

      /* Los chips se pintan ANTES del `return` de abajo: sin mapa (por
         ejemplo si Leaflet no cargo) la lista y sus filtros deben seguir
         funcionando igual. */
      if (chainsEl) chainsEl.innerHTML = chipsHTML();

      if (!smap) return;

      var pins = (shown || []).filter(hasCoords);

      /* El mapa esta siempre visible, pero QUE PINES muestra depende del
         estado (pedido del cliente, 2026-09-04):

         NADA BUSCADO NI FILTRADO -> mapa VACIO, sin un solo pin.
           Antes se volcaban las 189 tiendas y a nivel de pais los pines
           se amontonaban unos sobre otros en una mancha ilegible. Un mapa
           limpio invita a buscar; uno saturado no comunica nada. Las
           cards y los chips siguen ahi — solo se vacia el mapa.

         CHIP ACTIVO, SIN ZIP -> todas las tiendas de esa cadena.
           No hereda el corte de 50 cards: con "El Super" se veian 50 de
           sus 58 porque el mapa recibia la lista ya recortada. En el mapa
           ese limite no aporta — los pines no se recorren uno a uno.

         CON BUSQUEDA -> solo los resultados, que es lo que interesa. */
      if (!originPoint && !activeChain) {
        pins = [];
      } else if (!originPoint) {
        pins = stores.filter(function (s) {
          return hasCoords(s) && s.chain === activeChain;
        });
      }

      /* Si el ZIP buscado tiene tienda propia, el mapa se acerca a ELLA
         en vez de encuadrar todos los resultados del radio. Buscar 32822
         encuadraba las 9 tiendas de Florida y la del ZIP quedaba perdida
         entre las demas. */
      smap.show(pins, zipFocus());
      syncMapChrome(pins.length > 0);
    }

    /* Coordenada a la que acercar el mapa tras buscar, o null para que
       encuadre todos los pines. Solo devuelve algo cuando el ZIP escrito
       coincide EXACTAMENTE con el de una tienda: ahi el usuario busco un
       sitio concreto y ver su calle es mas util que ver la region. */
    function zipFocus() {
      if (!originPoint || !cbZip) return null;
      var zip = cbZip.getValue();
      if (!zip) return null;
      var own = null;
      for (var i = 0; i < stores.length; i++) {
        if (stores[i].zip === zip && hasCoords(stores[i])) { own = stores[i]; break; }
      }
      return own ? { lat: own.lat, lon: own.lon, zoom: 13 } : null;
    }

    /* Devuelve las tiendas pintadas como cards, o [] si lo que se mostró
       fue un mensaje (invitación o "sin resultados"). */
    function renderResults() {
      var hits = current();
      var zip = cbZip ? cbZip.getValue() : '';
      var any = !!zip || !!activeChain;

      if (resetEl) resetEl.classList.toggle('is-on', any);

      /* Con busqueda por proximidad, TODAS las tiendas del pais "califican"
         (siempre hay una distancia). Sin un corte, buscar en Los Angeles
         listaria tambien las de Florida al final. Se acota por radio, como
         Walmart — y si dentro del radio no cae ninguna, se ensancha una vez
         para no dejar al usuario con las manos vacias por unas millas. */
      if (originPoint) {
        var near = hits.filter(function (s) {
          return s.__dist != null && s.__dist <= RADIUS_MI;
        });
        /* Nada en 50 millas: se muestran las mas cercanas que haya, con el
           contador diciendo la verdad sobre la distancia real. */
        if (!near.length) {
          near = hits.filter(function (s) { return s.__dist != null; })
                     .slice(0, FALLBACK_COUNT);
          widened = near.length > 0;
        } else {
          widened = false;
        }
        hits = near;
      }

      /* Contador al estilo Walmart: "9 stores near 91331, within 50 miles".
         Ahora SI se puede prometer el radio, porque el filtro mide
         distancias reales (antes era coincidencia exacta de ZIP y decirlo
         habria sido mentir — ver §16 de la SPEC).

         Si hubo que ensanchar la busqueda, el texto lo dice en vez de
         fingir que esas tiendas estan "dentro de 50 millas". */
      if (countEl) {
        var noun = esc(hits.length === 1 ? cfg.t.store : cfg.t.stores);
        if (originPoint && zip) {
          var scope = widened
            ? esc(cfg.t.nearestTo || 'nearest to')
            : esc(cfg.t.near || 'near');
          /* El <span> mantiene "within 200 miles" en una sola linea: sin
             el, en movil se partia entre el numero y la unidad. */
          var radius = widened
            ? ''
            : ', <span class="cst-bar__radius">' +
              esc(cfg.t.within || 'within') + ' ' + RADIUS_MI + ' ' +
              esc(cfg.t.miles || 'miles') + '</span>';
          countEl.innerHTML = '<span class="cst-bar__pin" aria-hidden="true">' + ICON.pin + '</span>' +
            '<b>' + hits.length + '</b> ' + noun + ' ' + scope +
            ' <b>' + esc(zip) + '</b>' + radius;
        } else if (any) {
          countEl.innerHTML = '<b>' + hits.length + '</b> ' + noun;
        } else {
          countEl.innerHTML = '<b>' + stores.length + '</b> ' + esc(cfg.t.storesTotal);
        }
      }

      /* Sin ZIP no se vuelcan las 188 tiendas: se invita a buscar. Es el
         mismo criterio que Walmart, que tampoco lista el país entero. */
      /* Sin ZIP ya NO se muestra un mensaje pidiendo buscar: se listan
         tiendas directamente (pedido del cliente, 2026-09-04 — "cuando
         alguien entre que se carguen todas las tiendas de una").

         Se cortan en INITIAL_COUNT porque volcar las 189 cards de golpe
         alarga la pagina sin aportar: nadie recorre 189 tiendas a mano,
         para eso esta el buscador. El mapa, en cambio, si muestra las 189
         (ver render()) — ahi el conjunto completo si comunica algo.

         Sin punto de origen no hay distancias, asi que no hay un orden
         "correcto": cualquier criterio fijo (alfabetico, por estado)
         fingiria una relevancia que no existe hasta que el usuario diga
         donde esta.

         Por eso el orden inicial es ALEATORIO (pedido del cliente,
         2026-09-14). Antes se cortaban las 50 PRIMERAS del metaobject,
         siempre las mismas: las cadenas del final de la lista —Superior,
         Fiesta Mart, Tony's— no aparecian nunca en la portada, aunque
         sumen mas de un tercio del catalogo.

         El barajado se hace UNA VEZ por visita (`ordenInicial`), no en
         cada render: si se rebarajara al pulsar un chip o al limpiar el
         ZIP, las cards saltarian de sitio y pareceria un fallo. */
      if (!zip) {
        var initial = ordenInicial(hits).slice(0, INITIAL_COUNT);
        resEl.innerHTML = '<div class="cst-cards">' +
          initial.map(function (s) { return cardHTML(s, cfg); }).join('') + '</div>';
        return initial;
      }

      /* ZIP escrito pero fuera del alcance de la marca: resolveZip() no
         encontro el codigo ni en los centroides ni entre nuestras tiendas
         (ZIP inexistente, o texto que no es un codigo postal).
         Se dice claramente en vez de mostrar tiendas de otro estado con
         distancias inventadas — Canticos esta en 7 estados, buscar desde
         Nueva York es un caso real, no un error del usuario. */
      if (!originPoint) {
        resEl.innerHTML = '<div class="cst-empty"><strong>' +
          esc(cfg.t.tooFar || 'No Canticos stores near that ZIP code') +
          '</strong>' +
          esc(cfg.t.tooFarSub || 'We are in 7 states so far. Try another ZIP code.') +
          '</div>';
        return [];
      }

      if (!hits.length) {
        /* Con ZIP válido pero cadena sin tiendas ahí, los chips siguen
           visibles: son la vía para deshacer el filtro. */
        resEl.innerHTML =
          '<div class="cst-empty"><strong>' + esc(cfg.t.noMatch) +
          '</strong>' + esc(cfg.t.noMatchSub) + '</div>';
        return [];
      }

      /* Nada dentro del radio: se avisa ANTES de las cards en vez de
         mostrarlas sin contexto. El cliente lo pidio explicitamente
         ("si no hay en 50 millas agrega el mensaje no te preocupes").
         Sin este aviso, ver una tienda a 500 millas listada como
         resultado de tu busqueda es desconcertante. */
      var notice = '';
      if (widened) {
        notice = '<div class="cst-notice">' +
          esc(cfg.t.noneInRadius || 'No stores within') + ' ' + RADIUS_MI + ' ' +
          esc(cfg.t.miles || 'miles') + '. ' +
          esc(cfg.t.showingNearest || 'Showing the closest ones instead.') +
          '</div>';
      }

      resEl.innerHTML = notice + '<div class="cst-cards">' +
        hits.map(function (s) { return cardHTML(s, cfg); }).join('') + '</div>';
      return hits;
    }

    cbState = Combobox(wState, {
      t: cfg.t,
      onChange: function () { activeChain = ''; refreshCity(true); refreshZip(true); render(); }
    });
    cbCity = wCity ? Combobox(wCity, {
      t: cfg.t,
      onChange: cityChosen
    }) : null;
    /* freeText: el ZIP acepta CUALQUIER codigo, no solo los que tienen
       tienda. Es la base de la busqueda por proximidad — ver resolveZip().
       Las sugerencias del desplegable siguen ahi como ayuda, pero ya no
       son una restriccion. */
    cbZip = wZip ? Combobox(wZip, {
      t: cfg.t,
      onChange: zipChosen,
      freeText: true,   // acepta cualquier ZIP, no solo los que tienen tienda
      plain: true,      // sin desplegable: es un campo numerico normal
      /* Busca sola al llegar a 5 digitos, sin esperar Enter ni que el
         usuario salga del campo: escribir el ZIP y hacer scroll dejaba la
         lista sin actualizar. Ver el listener de `input`. */
      autoLength: 5,
      /* Etiqueta del boton cuando pasa a modo check (ver syncClear).
         Reutiliza una traduccion existente para no sumar un setting mas
         al schema, que ya roza el limite de Shopify. */
      confirmLabel: cfg.t.searchZip || 'Search this ZIP code'
    }) : null;

    if (!cbState) return;

    /* ---------------- "Use my current location" ----------------

       El navegador da la posicion; la tienda mas cercana se calcula con
       las coordenadas que ya viven en los metaobjects. Sin API de pago,
       sin servicio externo: es la ventaja de haber cargado los 188
       pares lat/lon.

       Se elige el ZIP de la tienda mas cercana, no un radio: el filtro
       de esta seccion es por codigo postal exacto (ver §16 de la SPEC),
       asi que llevar al usuario a "su" ZIP es lo coherente. */
    var geoBtn   = root.querySelector('[data-cst-geo]');
    var geoLabel = root.querySelector('[data-cst-geo-label]');

    /* Distancia en millas por la formula de Haversine. Es geometria
       esferica pura: no necesita red ni datos extra.

       Suficientemente exacta a esta escala — el error por no modelar el
       achatamiento de la Tierra es de metros en distancias de decenas de
       millas, y aqui solo hace falta ordenar tiendas por cercania. */
    function milesBetween(lat1, lon1, lat2, lon2) {
      var R = 3958.8;                      // radio terrestre en millas
      var rad = Math.PI / 180;
      var dLat = (lat2 - lat1) * rad;
      var dLon = (lon2 - lon1) * rad;
      var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
              Math.cos(lat1 * rad) * Math.cos(lat2 * rad) *
              Math.sin(dLon / 2) * Math.sin(dLon / 2);
      return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    /* El boton solo aparece si de verdad puede funcionar:
       - el navegador expone la API
       - la pagina va por HTTPS (Chrome y Safari la bloquean en HTTP;
         localhost es la excepcion, para poder probar en local)
       Mostrarlo cuando no puede funcionar solo genera un error. */
    if (geoBtn && navigator.geolocation) {
      var secure = window.isSecureContext ||
                   location.protocol === 'https:' ||
                   location.hostname === 'localhost' ||
                   location.hostname === '127.0.0.1';
      if (secure) geoBtn.hidden = false;
    }

    if (geoBtn) {
      /* Fuera del listener: la rama del permiso denegado tambien la usa,
         y ahi se llama desde el `.then()` de permissions.query. */
      var done = function (labelText, isError) {
        geoBtn.classList.remove('is-busy');
        if (geoLabel) geoLabel.textContent = labelText;
        geoBtn.classList.toggle('is-error', !!isError);
      };

      geoBtn.addEventListener('click', function () {
        if (geoBtn.classList.contains('is-busy')) return;   // doble clic

        /* Tras un error el boton mostraba el aviso y se quedaba asi. Un
           permiso denegado se puede conceder despues, y "sin tiendas
           cerca" cambia si el usuario se mueve: el primer clic sobre el
           mensaje devuelve el boton a su estado normal para reintentar. */
        if (geoBtn.classList.contains('is-error')) {
          geoBtn.classList.remove('is-error');
          if (geoLabel) geoLabel.textContent = cfg.t.geo || 'Use my current location';
          return;
        }

        /* Si el permiso ya esta DENEGADO de forma persistente, pedirlo
           otra vez no abre ningun dialogo: el navegador lo rechaza en
           silencio y el usuario ve el mismo error una y otra vez sin
           entender por que. Se comprueba antes y se le dice que el
           bloqueo esta en los ajustes del navegador, no en la pagina.

           `permissions.query` no existe en Safari < 16, asi que esto es
           una mejora progresiva: si no esta, se sigue el camino normal. */
        if (navigator.permissions && navigator.permissions.query) {
          navigator.permissions.query({ name: 'geolocation' }).then(function (st) {
            if (st.state === 'denied') {
              geoBtn.classList.remove('is-busy');
              done(cfg.t.geoDenied ||
                   'Location is blocked. Allow it in your browser settings, or enter your ZIP.',
                   true);
              return;
            }
            pedirPosicion();
          }).catch(pedirPosicion);
        } else {
          pedirPosicion();
        }
        return;
      });

      /* Extraido del listener para poder llamarlo despues de consultar
         el estado del permiso (que es asincrono). */
      function pedirPosicion() {
        geoBtn.classList.add('is-busy');
        if (geoLabel) geoLabel.textContent = cfg.t.geoBusy || 'Locating you…';

        navigator.geolocation.getCurrentPosition(function (pos) {
          var la = pos.coords.latitude, lo = pos.coords.longitude;

          var best = null, bestD = Infinity;
          stores.forEach(function (s) {
            if (!hasCoords(s)) return;
            var d = milesBetween(la, lo, s.lat, s.lon);
            if (d < bestD) { bestD = d; best = s; }
          });

          /* Sin tienda a menos de 150 millas no se fuerza un ZIP a la
             otra punta del pais: seria desorientador. Canticos esta en 7
             estados, asi que el caso es real. */
          if (!best || bestD > 150) {
            done(cfg.t.geoFar || 'No Canticos stores near you yet. Try another ZIP.', true);
            return;
          }

          done(cfg.t.geo || 'Use my current location', false);
          activeChain = '';

          /* Se mide desde la posicion REAL del usuario, no desde el ZIP
             de la tienda mas cercana: antes se hacia `cbZip.setValue(
             best.zip)` y se media desde ahi, un rodeo que perdia
             precision (la tienda mas cercana puede estar a millas del
             punto exacto donde esta la persona).

             El ZIP se rellena igual, pero solo como informacion visible
             de en que zona cayo la busqueda. */
          originPoint = { lat: la, lon: lo, exact: true };
          cbZip.setValue(best.zip);
          render();
          /* Tras el render el pin existe: se centra en la tienda que
             disparo la busqueda, no en el conjunto. */
          if (smap) smap.focus(storeUid(best));
        }, function (err) {
          /* Antes los tres errores daban EL MISMO mensaje generico
             ("Location unavailable"), asi que el usuario no sabia si
             tenia que conceder el permiso, reintentar o rendirse — el
             cliente lo reporto como "solo dice que no sirve y ya".

             Los codigos del navegador son tres y piden respuestas
             distintas:
               1 PERMISSION_DENIED     — el usuario (o el navegador) dijo
                                         que no. Hay que explicarle donde
                                         se vuelve a activar.
               2 POSITION_UNAVAILABLE  — el GPS/wifi no dio posicion.
                                         Reintentar suele funcionar.
               3 TIMEOUT               — tardo mas de lo permitido. Con
                                         GPS frio pasa a menudo.

             Ojo: en iOS Safari un permiso denegado NO se puede volver a
             pedir desde la pagina — el navegador ni siquiera muestra el
             dialogo otra vez. Por eso el mensaje manda a los ajustes del
             navegador en vez de invitar a pulsar de nuevo. */
          var msg;
          if (err && err.code === 1) {
            msg = cfg.t.geoDenied ||
                  'Location is blocked. Allow it in your browser settings, or enter your ZIP.';
          } else if (err && err.code === 3) {
            msg = cfg.t.geoTimeout ||
                  'Taking too long to locate you. Tap to retry, or enter your ZIP.';
          } else {
            msg = cfg.t.geoDeny ||
                  'Location unavailable. Enter your ZIP instead.';
          }
          done(msg, true);
        }, {
          /* enableHighAccuracy:true — antes iba en false "porque la
             precision de red es mas rapida". En un movil real eso hace
             que Android/iOS respondan con la posicion del operador, que
             puede errar decenas de millas o directamente no llegar; era
             una causa de TIMEOUT en la calle. Para elegir el supermercado
             mas cercano la precision si importa. */
          enableHighAccuracy: true,
          /* 10s se agotaban con el GPS frio, que es justo el caso de
             alguien que acaba de abrir la pagina en la calle. */
          timeout: 20000,
          maximumAge: 300000           // acepta una posicion de hasta 5 min
        });
      }
    }

    if (resetEl) {
      resetEl.addEventListener('click', function () {
        activeChain = '';
        /* Sin origen la lista deja de ordenarse por distancia y vuelve al
           estado inicial. Sin esto, limpiar el ZIP dejaba las tiendas
           ordenadas por una busqueda que ya no existe. */
        originPoint = null;
        cbState.clear();
        if (cbCity) cbCity.clear();
        if (cbZip) cbZip.clear();
        refreshCity(); refreshZip(); render();
        /* Antes habia un `root.scrollIntoView()` aqui: al pulsar Clear la
           pagina saltaba al tope de la seccion de golpe (el cliente lo
           describio como "una sacudida"). Limpiar un filtro no deberia
           mover al usuario de sitio — se queda donde esta viendo como la
           lista se actualiza sola. */
      });
    }

    if (helpTrigger && helpEl) {
      var helpTextOpen  = cfg.t.helpHide || 'Hide ways to help';
      var helpTextClose = (helpLabel && helpLabel.textContent) || '';
      helpTrigger.addEventListener('click', function () {
        var open = helpEl.classList.toggle('is-open');
        helpTrigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (helpLabel) helpLabel.textContent = open ? helpTextOpen : helpTextClose;
      });
    }

    // Un clic fuera cierra cualquier lista abierta
    document.addEventListener('mousedown', function (e) {
      if (!root.contains(e.target)) {
        root.querySelectorAll('[data-cst-listbox]').forEach(function (lb) {
          lb.hidden = true;
          var inp = lb.parentElement.querySelector('[data-cst-input]');
          if (inp) inp.setAttribute('aria-expanded', 'false');
        });
      }
    });

    injectDefs();
    cbState.setOptions(tally(stores, 'state_name', 'count'), cfg.t.allStates);
    cbState.setEnabled(true);
    refreshCity();
    refreshZip();
    render();

    root.dataset.cstReady = '1';
  }

  function init() {
    document.querySelectorAll('[data-cst-locator]').forEach(Locator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // El editor de temas recarga secciones sin refrescar la pagina
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-cst-locator]');
    if (root) { delete root.dataset.cstReady; Locator(root); }
  });
})();
